// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__54N_g","scrollContainer":"styles_scrollContainer__cEDIu"};